/*
  LoadingMask renders a full-viewport overlay with a centered spinner.
  No special positioning is required on the parent element.

  example:
    <LoadingMask loading={isLoading} />
*/

import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

interface LoadingMaskProps {
  loading: boolean;
}

const LoadingMask: React.FC<LoadingMaskProps> = props => {
  const { loading } = props;
  return (
    <Backdrop
      open={loading}
      sx={theme => ({
        position: 'fixed',
        zIndex: theme.zIndex.modal + 1,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      })}
    >
      <CircularProgress aria-label={'progress spinner'} aria-busy={loading} hidden={!loading} size={50} />
    </Backdrop>
  );
};

export default LoadingMask;
